import { RefundFormTemplate } from "../../Templates/RefundFormTemplate";

export const RefundForm = () => {
  return <RefundFormTemplate />;
};
